<template>
  <div class="login">
    <header class="container1">
      <!-- <div class="logo">
        <router-link to="/" target="_blank">
          <img class="img" src="@/assets/img/LOGO.png" alt />
        </router-link>
        <h1>买家具多比·多比多实惠</h1>
      </div> -->
      <p class="test">{{title}}</p>
    </header>

    <slot></slot>

    <footer class="container1">
      <p class="icp">
        <span v-if="!isShopView">Copyright ©2020-{{new Date().getFullYear()}} 多比duobihouse.com版权所有。ICP备案证书号：</span>
        <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          <span>{{hostNo}}</span>
        </a>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "欢迎登录",
    },
    GetShopInfoNoLogin: {
      type: Function,
      default: () => {},
    },
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hostNo: "",
    };
  },
  mounted() {
    if (this.isShopView) {
      this.getShopInfoNoLogin();
    } else {
      this.hostNo = "蜀ICP备20022182号-1";
    }
  },
  methods: {
    getShopInfoNoLogin() {
      this.GetShopInfoNoLogin({ aloneDo: true }).then((res) => {
        // console.log("获取店铺信息", res);
        this.hostNo = res.data[0].hostRecordNo;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  color: #333333;
  header {
    padding: 18px 0 14px;
    display: flex;
    align-items: center;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .img {
        width: auto;
        height: auto;
      }
      h1 {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 6px;
      }
    }
    .test {
      font-size: 18px;
      font-weight: 500;
      margin-left: 22px;
      padding-left: 23px;
      position: relative;
      &::before {
        display: none;
        content: "";
        position: absolute;
        left: 0px;
        top: 50%;
        margin-top: -10px;
        width: 1px;
        height: 20px;
        background: #737373;
      }
    }
  }
  footer {
    height: 200px;
    text-align: center;
    .icp {
      padding-top: 82px;
      font-size: 12px;
      font-weight: 500;
      a {
        color: #333333;
      }
    }
  }
}
</style>